import revive_payload_client_4sVQNw7RlN from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_eTVJQYlCmx from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import gtag_client_Zw8EQXNVTz from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/plugins/gtag.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  plugin_eTVJQYlCmx,
  chunk_reload_client_UciE0i6zes,
  gtag_client_Zw8EQXNVTz
]